import React from 'react'

const Loading: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-500 mx-auto"></div>
        <p className="mt-4 text-gray-600 text-lg">Cargando...</p>
      </div>
    </div>
  )
}

export default Loading
